import createIcon from '../../createIcon';

/**
 * @component @name PermCameraMic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNUgxNi44M0wxNSAzSDlMNy4xNyA1SDRDMi45IDUgMiA1LjkgMiA3VjE5QzIgMjAuMSAyLjkgMjEgNCAyMUgxMVYxOC45MUM4LjE3IDE4LjQzIDYgMTUuOTcgNiAxM0g4QzggMTUuMjEgOS43OSAxNyAxMiAxN0MxNC4yMSAxNyAxNiAxNS4yMSAxNiAxM0gxOEMxOCAxNS45NyAxNS44MyAxOC40MyAxMyAxOC45MVYyMUgyMEMyMS4xIDIxIDIyIDIwLjEgMjIgMTlWN0MyMiA1LjkgMjEuMSA1IDIwIDVaTTE0IDEzQzE0IDE0LjEgMTMuMSAxNSAxMiAxNUMxMC45IDE1IDEwIDE0LjEgMTAgMTNWOUMxMCA3LjkgMTAuOSA3IDEyIDdDMTMuMSA3IDE0IDcuOSAxNCA5VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermCameraMic = createIcon('PermCameraMic', [
  [
    'path',
    {
      d: 'M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H11V18.91C8.17 18.43 6 15.97 6 13H8C8 15.21 9.79 17 12 17C14.21 17 16 15.21 16 13H18C18 15.97 15.83 18.43 13 18.91V21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM14 13C14 14.1 13.1 15 12 15C10.9 15 10 14.1 10 13V9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9V13Z',
      key: '2x0nn1',
    },
  ],
]);

export default PermCameraMic;
